var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 14.5894C9.82729 17.0171 6.85093 17.3519 4.41521 16.2162C1.97822 15.08 0.0800781 12.4699 0.0800781 9.00009C0.0800781 5.53031 1.97822 2.92018 4.41521 1.78394C6.85093 0.648301 9.82719 0.98303 11.9998 3.41063C14.79 6.51512 14.7901 11.4849 11.9999 14.5894ZM10.1636 16.8544C11.3732 16.2325 12.3934 15.3555 13.2244 14.3039H15.2694C13.9141 15.8904 12.2724 16.766 10.1636 16.8544ZM13.664 13.5182C14.0759 12.8109 14.388 11.9297 14.6022 10.9603H16.806C16.5852 11.9463 16.2607 12.827 15.7385 13.5182H13.664ZM10.1636 1.14575C12.2724 1.23413 13.9141 2.10976 15.2694 3.69622H13.2244C12.3934 2.64473 11.3732 1.76772 10.1636 1.14575ZM13.6559 4.37749H15.7354C16.2605 5.16808 16.5854 6.05453 16.806 7.03987H14.6022C14.3861 6.06175 14.0708 5.17412 13.6559 4.37749ZM16.938 10.279H14.7303V7.72115H16.938V10.279Z",
    stroke: "#F6F6F6",
    strokeWidth: 0.158824
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.1fa8b7ce45e79d04356cc508be95d9bc.svg";
export { ForwardRef as ReactComponent };